import { render, staticRenderFns } from "./editDepartment.vue?vue&type=template&id=4798d0d8&scoped=true"
import script from "./editDepartment.vue?vue&type=script&lang=js"
export * from "./editDepartment.vue?vue&type=script&lang=js"
import style0 from "./editDepartment.vue?vue&type=style&index=0&id=4798d0d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4798d0d8",
  null
  
)

export default component.exports